(function() {
    'use strict';

    angular
        .module('etrrbApp', ['corePRUGAGreatApp'])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();

